var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{staticClass:"btn btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bold px-5",class:{'pointer-events-none opacity-50': _vm.disabled},attrs:{"as":"button","href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }